<template lang="html">
  <v-app class="large-screen__body white">
    <div class="outer-div">
      <v-toolbar dark tabs>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text center">
          ORGANIZE
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tabs grow fixed-tabs centered slot="extension" class="primary-tabs">
          <v-tab :to="{name: 'OrganizerProjects'}">
            Projects
          </v-tab>
          <v-tab :to="{name: 'OrganizerTasks'}">
            Effort
          </v-tab>
          <v-tab :to="{name: 'OrganizerCompletions'}">
            Complete
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <div id="show" class="body">
        <router-view></router-view>
      </div>
    </div>
  </v-app>
</template>


<script>
export default {
  mounted() {
    this.$store.dispatch('users/fetchUserProfile');
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
  .outer-div {
    height: 100%;
  }

  .body {
    padding-top: 20px;
    padding-left: 10px;
    padding-right: 10px;

    span {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/OrganizeLayout.vue